
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BenefitsProps {
  benefits: string[] | null;
}

const Benefits: React.FC<BenefitsProps> = ({ benefits }) => {
  const { t } = useTranslation();
  
  // Aseguramos que benefits sea un array
  const ensureBenefitsArray = (benefits: string[] | null): string[] => {
    if (!benefits) return [];
    if (!Array.isArray(benefits)) return [String(benefits)];
    return benefits;
  };
  
  // Seleccionamos los beneficios basados en el idioma actual
  const languageSpecificBenefits = ensureBenefitsArray(benefits);
  
  if (languageSpecificBenefits.length === 0) return null;
  
  // Show only the first 2 benefits
  const displayBenefits = languageSpecificBenefits.slice(0, 2);
  const hasMoreBenefits = languageSpecificBenefits.length > 2;
  
  return (
    <div className="mb-6">
      <h3 className="font-medium text-base mb-2">{t('benefits')}</h3>
      <ul className="list-disc list-inside text-sm text-gray-600">
        {displayBenefits.map((benefit, index) => (
          <li key={index}>{benefit}</li>
        ))}
        {hasMoreBenefits && (
          <li className="text-sangre-500">+{languageSpecificBenefits.length - 2} {t('moreItems')}</li>
        )}
      </ul>
    </div>
  );
};

export default Benefits;
